import { ProjectCreationMethod } from 'types';
import bem from 'utils/bem';

export const block = bem('video-wizard');

export const getProjectCreationMethod = (
  isClipSuggestion: boolean,
  isFullEpisodeExport: boolean,
): ProjectCreationMethod => {
  // For clip suggestions there is no distinction between full episode and clip yet.
  if (isClipSuggestion) {
    return 'videoTranscriptClipSuggestion';
  }

  // For single clips it is necessary to check between full episode and regular transcripts.
  if (isFullEpisodeExport) {
    return 'videoTranscriptEpisode';
  }

  return 'videoTranscript';
};

export function calculateUploadProgressPortion(fileSizeBytes: number): number {
  const MAX_FILE_SIZE_MB = 5000;
  const MIN_PORTION = 5;
  const MAX_PORTION = 30;

  const fileSizeMb = fileSizeBytes / 1024 ** 2;
  const clampedSizeMb = Math.min(fileSizeMb, MAX_FILE_SIZE_MB);
  const portion =
    MIN_PORTION +
    (clampedSizeMb / MAX_FILE_SIZE_MB) * (MAX_PORTION - MIN_PORTION);

  return Math.round(portion);
}
